{
  "meta": {
    "theme_toggle_aria": "Toggle theme"
  },
  "nav": {
    "features": "Features",
    "product": "Product",
    "pricing": "Pricing",
    "faq": "FAQ",
    "login": "Sign in",
    "register": "Start free",
    "my_account": "My account"
  },
  "hero": {
    "eyebrow_pill": "New",
    "eyebrow_text": "AI meetings — automatic transcription and summary",
    "title_1": "Where",
    "title_2": "brilliant",
    "title_3": "teams",
    "title_4": "build",
    "title_5": "real",
    "title_6": "things",
    "title_7": "together.",
    "sub_html": "Tasks, projects, live chat, and <strong>AI meetings</strong> on a single canvas. Record, let AI transcribe and summarize — and turn every agreement into a task with one click.",
    "cta_register": "Start free — 14 days of Pro",
    "cta_account": "Go to my account",
    "cta_see_product": "See the product",
    "download_play": "Get it on Google Play",
    "download_play_meta": "Android",
    "download_play_title": "Download Tworks for Android on Google Play",
    "meta_no_card": "No credit card",
    "meta_setup": "Setup in 2 minutes",
    "meta_cancel": "Cancel anytime",
    "sticker_completed": "Task completed",
    "sticker_completed_meta": "just now",
    "sticker_comment": "Andrea just commented",
    "sticker_comment_meta": "\"Approved ✅ moving to dev\"",
    "url_bar": "app.pavemi.com / meetings / daily-standup",
    "sidebar_space": "Workspace",
    "sidebar_work": "Work",
    "sidebar_home": "Home",
    "sidebar_my_tasks": "My tasks",
    "sidebar_inbox": "Inbox",
    "sidebar_projects": "Projects",
    "sidebar_project_1": "Landing redesign",
    "sidebar_project_2": "Q2 campaign",
    "sidebar_project_3": "Backend infra",
    "demo_aria": "Animated demo of the AI meetings feature",
    "demo_title": "Daily standup — product team",
    "demo_meta": "Meeting · 2:30 PM",
    "record_btn": "Record meeting",
    "transcript_a_text": "We need to close the Stripe integration this week.",
    "transcript_m_text": "I'll take care of the invoices webhook.",
    "transcript_s_text": "We need QA on the upgrade flow before Friday.",
    "tasks_label": "Auto-created tasks",
    "task_1": "Close Stripe integration",
    "task_2": "Implement invoices webhook",
    "task_3": "QA the upgrade flow"
  },
  "demo_video": {
    "title_html": "See Tworks in <em>60 seconds</em>",
    "subtitle": "The essentials: AI meetings, collaborative kanban, and the whole workflow on a single canvas.",
    "unsupported": "Your browser doesn't support HTML5 video."
  },
  "marquee": [
    "Replaces Asana, Trello and Notion",
    "Meetings that transcribe themselves",
    "AI summary per project",
    "End-to-end encrypted",
    "\"My team stopped arguing on Slack\""
  ],
  "features": {
    "kicker": "01 — Features",
    "title_html": "Everything your team needs,<br><em>nothing it doesn't.</em>",
    "sub": "Stop jumping between six apps. Tworks integrates the essentials on a single, carefully designed surface.",
    "kanban_title_html": "<em>Kanban</em> board",
    "kanban_body": "Drag and drop between columns. Visualize your team's flow without opening five tabs.",
    "kanban_col_pending": "To do",
    "kanban_col_in_progress": "In progress",
    "kanban_col_done": "Done",
    "kanban_card_1": "Hero mockup",
    "kanban_card_2": "CSS bug",
    "kanban_card_3": "Auth API",
    "kanban_card_4": "Setup",
    "calendar_title_html": "<em>Calendar</em> view",
    "calendar_body": "Plan deliveries and deadlines visually. Drag & drop to reschedule.",
    "calendar_month": "April",
    "calendar_week": "Week 17",
    "ai_title_html": "<em>AI</em> meetings",
    "ai_body": "Record from the browser. AI transcribes and summarizes — then you turn every agreement into a task with one click.",
    "ai_recording": "Recording",
    "ai_quote": "\"Andrea is going to prep the deck for Friday…\"",
    "chat_title_html": "<em>Live</em> chat",
    "chat_body": "Every task is a mini-chat. {'@'}mentions, files, all in context.",
    "chat_msg_1_name": "Andrea",
    "chat_msg_1_text": "Uploaded the client deck 📊",
    "chat_msg_2_name": "Marco",
    "chat_msg_2_text_html": "<span class=\"mention\">{'@'}Andrea</span> reviewed, ready",
    "notif_title_html": "<em>Clean</em> notifications",
    "notif_body": "Only what involves you. Not the noise of the whole org.",
    "notif_1_html": "<strong>Marco</strong> assigned you <strong>\"Review PR #247\"</strong>",
    "notif_1_time": "2m ago",
    "notif_2_html": "<strong>Andrea</strong> mentioned you in <strong>\"Client deck\"</strong>",
    "notif_2_time": "1h ago",
    "closer_title_html": "Built so <em>everything</em> has its place.",
    "closer_body": "Timeline view, executive reports, teams and departments, dark mode, global search, attachments up to 100MB, subtasks, tags, keyboard shortcuts. Every detail designed to stay out of the way.",
    "tag_timeline": "Timeline",
    "tag_reports": "Reports",
    "tag_ai_summary": "AI summary",
    "tag_multi_team": "Multi-team",
    "tag_departments": "Departments",
    "tag_subtasks": "Subtasks",
    "tag_attachments": "Attachments",
    "tag_tags": "Tags",
    "tag_global_search": "Global search",
    "tag_palette": "⌘K palette",
    "tag_dark": "Dark mode",
    "tag_pwa": "PWA",
    "tag_sso": "Google SSO"
  },
  "showcase": {
    "kicker": "02 — Product",
    "title_html": "See <em>what it looks like</em> to work better.",
    "task_detail": {
      "kicker": "Task detail",
      "title_html": "Context <em>never</em> gets lost.",
      "body": "Comments, assignees, dates, tags, attachments, and subtasks — all in one panel. What used to live scattered across Slack, Drive, and email is now where it belongs: next to the work.",
      "li_1_html": "<strong>Real-time chat</strong> via WebSocket — you see when someone is typing",
      "li_2_html": "<strong>{'@'}mentions</strong> that notify instantly",
      "li_3_html": "<strong>Attachments up to 100 MB</strong> — drag & drop directly",
      "link": "Try it with your team",
      "annot": "Task with full context",
      "url": "task / Design hero components",
      "breadcrumb": "LANDING REDESIGN / DESIGN",
      "task_title": "Design hero components",
      "status": "In progress",
      "comments_label": "Comments · 3",
      "comment_1_name": "Andrea",
      "comment_1_time": "10:24",
      "comment_1_text": "I made progress with two hero versions. A is more editorial, B more classic.",
      "comment_2_name": "Marco",
      "comment_2_time": "10:28",
      "comment_2_text_html": "<span class=\"mention\">{'@'}Andrea</span> I'll go with A. Let's ship that one.",
      "comment_3_name": "Sindy",
      "comment_3_time": "now",
      "comment_3_text_html": "Approved ✅. <span class=\"mention\">{'@'}Marco</span> ready to move to dev.",
      "field_assignees": "Assignees",
      "field_due": "Due date",
      "field_due_value": "Apr 29",
      "field_priority": "Priority",
      "field_priority_value": "High",
      "field_tags": "Tags",
      "field_tag_1": "Design",
      "field_tag_2": "Hero",
      "field_attachments": "Attachments"
    },
    "ai_meetings": {
      "kicker": "AI meetings",
      "title_html": "From voice to tasks, <em>no note-taking.</em>",
      "body": "Record directly from the browser or upload an audio. Whisper transcribes in minutes and an executive summary extracts agreements, decisions, and next steps. Review, edit, and turn each action into an assigned task.",
      "li_1_html": "<strong>Accurate transcription</strong> with Whisper-large-v3",
      "li_2_html": "<strong>Structured summary</strong>: topics, decisions, next steps",
      "li_3_html": "<strong>One-click tasks</strong> — review and commit",
      "li_4_html": "Audio with <strong>auto retention</strong> (90 days) and secure deletion",
      "annot": "Ready to review",
      "url": "app.pavemi.com / meetings / sync-q2",
      "meeting_title": "Sync Q2",
      "meeting_meta": "Apr 28 · 32 min",
      "transcript_label": "Transcript",
      "transcript_a_html": "<strong style=\"color:var(--teal-2);\">Andrea —</strong> I'll close the client deck by Friday. I need Marco to approve the pricing section before Thursday.",
      "transcript_m_html": "<strong style=\"color:var(--amber-2);\">Marco —</strong> Got it. If it arrives Thursday morning I'll review it that day.",
      "transcript_s_html": "<strong style=\"color:var(--ink-2);\">Sindy —</strong> I'll coordinate the product demo on Tuesday at 10.",
      "summary_label": "AI summary",
      "summary_text": "Q2 status sync: closing client deck, pricing alignment, and product demo.",
      "tasks_label_html": "Proposed tasks <span style=\"color:var(--teal-2)\">· 3</span>",
      "task_1": "Close client deck",
      "task_2": "Approve pricing section",
      "task_3": "Coordinate product demo",
      "confirm_button": "Confirm 3 tasks"
    },
    "calendar": {
      "kicker": "Calendar",
      "title_html": "From task list to <em>executable plan.</em>",
      "body": "Place each task on the calendar. See at a glance what's coming this week and where the load piles up. Reassign dates with drag & drop.",
      "li_1_html": "<strong>Month, week</strong> view",
      "li_2_html": "<strong>Drag & drop</strong> to reschedule",
      "li_3_html": "Automatic <strong>due date</strong> alerts",
      "annot": "Today highlighted",
      "url": "app.pavemi.com / calendar",
      "month": "April 2026",
      "tab_month": "Month",
      "tab_week": "Week",
      "tab_list": "List",
      "dow_mon": "Mon",
      "dow_tue": "Tue",
      "dow_wed": "Wed",
      "dow_thu": "Thu",
      "dow_fri": "Fri",
      "dow_sat": "Sat",
      "dow_sun": "Sun",
      "event_1": "Client brief",
      "event_2": "Demo 2:00 PM",
      "event_3": "Q2 deadline",
      "event_4": "Review",
      "event_5": "Hero v2",
      "event_6": "Sync"
    },
    "my_tasks": {
      "kicker": "My tasks",
      "title_html": "Your day. Your pace. <em>Your focus.</em>",
      "body": "\"My tasks\" gathers everything assigned to you in one place — regardless of project. Sort by priority or date. Done with one click.",
      "li_1_html": "<strong>Standalone</strong> tasks (no project) — for personal stuff",
      "li_2_html": "One task, <strong>multiple projects</strong>",
      "li_3_html": "Keyboard shortcuts everywhere",
      "annot": "Click to complete",
      "url": "app.pavemi.com / my-tasks",
      "greeting": "Good morning, Leo",
      "subtitle_html": "You have <strong style=\"color: var(--teal-2)\">6 tasks</strong> this week",
      "today_label": "Today",
      "task_done": "Set up dev environment",
      "task_done_tag": "Backend",
      "task_1": "Implement OAuth authentication",
      "task_1_tag": "High",
      "task_2": "Design metrics dashboard",
      "task_2_tag": "Medium",
      "tomorrow_label": "Tomorrow",
      "task_3": "Review PR #247 — API endpoints",
      "task_3_tag": "High",
      "task_4": "Write integration tests",
      "task_4_tag": "Medium"
    }
  },
  "pricing": {
    "kicker": "03 — Pricing",
    "title_html": "Simple. <em>Honest.</em><br>No surprises.",
    "sub": "Start free. Unlock Pro when your team grows. Cancel anytime.",
    "free_name": "Free",
    "free_tag": "For starting out and personal projects",
    "free_per": "/ forever",
    "free_feat_1_html": "Up to <strong>10 members</strong>",
    "free_feat_2_html": "<strong>1000 active tasks</strong>",
    "free_feat_3_html": "<strong>Kanban + List</strong> views",
    "free_feat_4": "Live chat + attachments (10 MB/file)",
    "free_feat_5_html": "<strong>500 MB</strong> storage",
    "free_feat_6": "In-app notifications",
    "free_cta": "Start free",
    "free_cta_in": "Go to my account",
    "pro_badge": "14 days free",
    "pro_name": "Pro",
    "pro_tag": "AI + smart meetings for growing teams",
    "pro_per": "/ workspace / month",
    "pro_feat_1_html": "<strong>5 seats included</strong> · $4 per extra seat",
    "pro_feat_2_html": "<strong>AI meetings</strong> · 600 min/month (up to 2h per meeting)",
    "pro_feat_3_html": "Executive <strong>AI summary</strong> per project",
    "pro_feat_4_html": "<strong>Calendar and Timeline</strong> views",
    "pro_feat_5": "Reports and dashboards",
    "pro_feat_6_html": "<strong>20 GB</strong> · attachments up to 100 MB",
    "pro_feat_7": "Time tracking · Tags · Custom fields",
    "pro_cta": "Try 14 days free",
    "pro_cta_in": "View my plan",
    "business_name": "Business",
    "business_tag": "Unlimited AI + enterprise control",
    "business_feat_1_html": "<strong>Everything in Pro</strong> with 15 seats included, plus:",
    "business_feat_2_html": "<strong>3000 min/month</strong> AI meetings (up to 4h per meeting)",
    "business_feat_3_html": "<strong>100 GB</strong> · attachments up to 500 MB",
    "business_feat_4": "Portfolios, goals, and workload",
    "business_feat_5": "Approvals and external guests",
    "business_feat_6": "SSO · Public API · Webhooks",
    "business_feat_7": "Priority support",
    "business_cta": "Talk to sales",
    "note": "Annual billing available (2 months free). Cancel anytime — when you cancel Pro, you revert to Free without losing data."
  },
  "faq": {
    "kicker": "04 — Questions",
    "title_html": "What you're <em>probably</em><br>wondering.",
    "q1": "Do I need a credit card to start?",
    "a1": "No. The Free plan is forever, no card required. When you sign up, you get 14 days of Pro automatically — at expiration, your account goes back to Free, no charges, no lost data.",
    "q2": "How do AI meetings work?",
    "a2": "You record from the browser (or upload an audio). Tworks transcribes with Whisper-large-v3 and generates a structured summary: topics, decisions, and next steps. You review, edit, and turn agreements into assigned tasks with one click. Audio is automatically deleted after 90 days by default. Pro: 600 minutes/month, up to 2h per meeting. Business: 3000 min/month, up to 4h.",
    "q3": "Can I import my tasks from Asana or Trello?",
    "a3": "Yes. We support CSV and JSON import from the most common tools. For large migrations, we'll help you personally at no cost.",
    "q4": "Is my data safe?",
    "a4": "TLS 1.3 encryption in transit and AES-256 at rest. Daily automatic backups. Hosting on SOC 2 Type II infrastructure. And you can always export everything in an open format.",
    "q5": "Does it work offline?",
    "a5": "Reading yes, via local cache. Writing requires connection — to keep everything synced in real time across devices.",
    "q6": "Is there a mobile app?",
    "a6": "Yes. Tworks for Android is live on Google Play — free, with the same account. On iPhone and iPad, install the web app from Safari (Share → Add to Home Screen); the native iOS app is on its way."
  },
  "big_cta": {
    "title_html": "Stop managing chaos.<br>Start <em>building.</em>",
    "sub": "Join hundreds of teams already using Tworks to ship more, with less stress and more focus.",
    "register": "Create my free account",
    "account": "Go to my account",
    "see_product": "See the product"
  },
  "footer": {
    "brand_sub": "The workspace where brilliant teams build real things.",
    "product_col": "Product",
    "product_features": "Features",
    "product_demo": "Demo",
    "product_pricing": "Pricing",
    "product_changelog": "Changelog",
    "account_col": "Account",
    "account_register": "Sign up",
    "account_login": "Sign in",
    "account_my": "My account",
    "account_billing": "My plan",
    "account_faq": "FAQ",
    "account_contact": "Contact",
    "legal_col": "Legal",
    "legal_privacy": "Privacy",
    "legal_terms": "Terms",
    "legal_security": "Security",
    "copyright": "© 2026 Tworks · Crafted with care in Honduras 🇭🇳",
    "tagline": "— chaos is not a system —"
  },
  "privacy": {
    "title": "Privacy Policy",
    "last_updated": "Last updated: August 1, 2026",
    "intro": "This policy describes how Tworks, operated by Moniteck, collects, uses, and protects your data when you use our project and task management application, both on the web and in the Android and iOS apps. By creating an account or using Tworks, you accept the practices described here.",
    "sections": [
      {
        "title": "1. Information we collect",
        "groups": [
          {
            "subtitle": "Account data",
            "items": [
              { "text": "Your name and email address when you create an account." },
              { "text": "The password you choose, stored hashed; we never read it in plain text." },
              { "text": "If you sign up with Google or Apple, we receive your name, email, and user identifier from that provider. We do not receive your password." }
            ]
          },
          {
            "subtitle": "Content you create",
            "items": [
              { "text": "Tasks, projects, comments, and file attachments you upload to the platform." },
              { "text": "Meeting audio recordings, along with the transcripts and summaries generated from them." },
              { "text": "Team member invitations, which include the recipient's email address." }
            ]
          },
          {
            "subtitle": "Technical data",
            "items": [
              { "text": "Push notification tokens (Google FCM and Apple APNs) to send you alerts about tasks and mentions." },
              { "text": "IP address in operational server logs, truncated or anonymized; it is not linked to your user profile." },
              { "text": "App error and performance information (details in section 3)." }
            ]
          },
          {
            "subtitle": "Billing data",
            "items": [
              { "text": "If you subscribe to a paid plan, payment processing is handled by Stripe. We neither store nor see your full card number: we only keep the subscription identifier and its status." }
            ]
          }
        ]
      },
      {
        "title": "2. How we use your data",
        "items": [
          { "label": "Operating the service", "text": "creating and managing your account, projects, tasks, and team." },
          { "label": "Transcription and AI", "text": "meeting audio is sent to external services (see section 3) to generate transcripts and automatically extract tasks." },
          { "label": "Notifications", "text": "using your push token to send you alerts about assignments, mentions, and task updates." },
          { "label": "Billing", "text": "managing your subscription, charges, and renewals if you use a paid plan." },
          { "label": "Product improvement", "text": "anonymized usage analytics to understand which features are useful and to detect problems." },
          { "label": "Service communications", "text": "transactional emails about your account (team invitations, password changes, important notices)." }
        ],
        "footer": "We do not use your data for third-party advertising, nor do we share it for commercial purposes unrelated to the service."
      },
      {
        "title": "3. Third-party services",
        "body": "To operate Tworks we share specific data with the following processors, under data processing agreements:",
        "items": [
          { "label": "Groq Inc.", "text": "audio transcription with the Whisper model. It receives the meeting audio file during processing and does not retain it beyond the time required.", "href": "https://groq.com/privacy-policy/", "link_label": "View policy" },
          { "label": "Anthropic PBC", "text": "automatic task extraction with Claude. It receives only the text transcript, not the audio.", "href": "https://www.anthropic.com/legal/privacy", "link_label": "View policy" },
          { "label": "Stripe, Inc.", "text": "payment processing and subscription management. It receives your billing data directly; it does not pass through our servers.", "href": "https://stripe.com/privacy", "link_label": "View policy" },
          { "label": "Sentry", "text": "error reporting and diagnostics. It may capture stack traces and device metadata when a failure occurs.", "href": "https://sentry.io/privacy/", "link_label": "View policy" },
          { "label": "PostHog", "text": "anonymized usage analytics (navigation events, features used). It does not include task content or identifiable personal data.", "href": "https://posthog.com/privacy", "link_label": "View policy" },
          { "label": "Google Firebase Cloud Messaging and Apple Push Notification Service", "text": "delivery of push notifications on Android and iOS devices respectively." },
          { "label": "Hosting infrastructure", "text": "our servers, where the database, file attachments, and audio recordings are stored." }
        ],
        "footer": "Cookies: we use technical cookies to keep you signed in. Unless you tell us otherwise, we also use PostHog (anonymous analytics) and Sentry (error reporting). We do not use marketing or remarketing cookies. We do not sell your data to third parties for any purpose."
      },
      {
        "title": "4. Retention and deletion",
        "callout": "Meeting recordings: audio is automatically deleted 90 days after it is processed. You can delete it sooner at any time from the meetings list inside the app.",
        "items": [
          { "label": "Account and content", "text": "retained while the account is active. When you delete your account, all associated data is erased within a maximum of 30 days." },
          { "label": "Transcripts and summaries", "text": "deleted along with the corresponding meeting, either manually or by the automatic 90-day deletion." },
          { "label": "Operational logs", "text": "retained for 30 days and then purged automatically." },
          { "label": "Push tokens", "text": "deleted when you sign out or delete your account." },
          { "label": "Billing data", "text": "invoices are retained for as long as applicable tax regulations require, even after the account is closed." }
        ]
      },
      {
        "title": "5. Your rights",
        "body": "Depending on your jurisdiction, you may exercise the following rights over your personal data:",
        "items": [
          { "label": "Access", "text": "review what information we hold about you from within the app." },
          { "label": "Correction", "text": "update your name and email at any time from your profile settings." },
          { "label": "Deletion", "text": "delete your account from Settings → Danger zone inside the app. Deletion is permanent and irreversible." },
          { "label": "Export", "text": "request a copy of your data by writing to us. Automatic export from within the app is not yet available." },
          { "label": "Objection or restriction", "text": "you may ask us to stop processing your data for certain purposes by contacting us directly." }
        ],
        "footer": "We respond to requests within a maximum of 30 days. If you have concerns about how your data is handled, you have the right to lodge a complaint with the data protection authority in your country."
      },
      {
        "title": "6. Security",
        "body": "We apply reasonable technical and organizational measures to protect your data: encryption in transit (HTTPS/TLS), secure session tokens, and restricted access to production data. No system is infallible; if you find a vulnerability, we ask that you report it by email before disclosing it publicly."
      },
      {
        "title": "7. International transfers",
        "body": "Some of the services mentioned (Groq, Anthropic, Stripe, Sentry, PostHog, Google, Apple) process data on servers located outside your country of residence. These providers have appropriate transfer mechanisms in place under applicable regulations. We are working toward compliance with the GDPR (European Union), the LFPDPPP (Mexico), and the LGPD (Brazil), as applicable to the user."
      },
      {
        "title": "8. Children and minors",
        "body": "Tworks is not directed at people under 13 years of age, and we do not knowingly collect data from minors. If you are a parent or guardian and believe your child has provided personal data, contact us so we can delete it immediately."
      },
      {
        "title": "9. Changes to this policy",
        "body": "We may update this policy to reflect changes in the product or in applicable legislation. We will notify you by email at least 15 days in advance of material changes. The date at the top of this document indicates the version in effect."
      }
    ],
    "contact_title": "10. Contact",
    "contact_body": "If you have questions, requests, or concerns about how your data is handled, write to us at:",
    "contact_email": "privacidad{'@'}moniteck.com",
    "contact_footer": "We will do our best to respond within 5 business days.",
    "back": "Back to home"
  },
  "terms": {
    "title": "Terms of Service",
    "last_updated": "Last updated: January 2026",
    "intro": "By using Tworks you agree to these terms. Read them carefully.",
    "section_1_title": "Account",
    "section_1_body": "You're responsible for keeping your password secure and for the activity on your account. You must be at least 18 years old to create an account.",
    "section_2_title": "Acceptable use",
    "section_2_body": "Don't use Tworks for illegal activities, spam, malware, or to harass other users. We reserve the right to suspend accounts that violate these terms.",
    "section_3_title": "Payments and cancellation",
    "section_3_body": "Paid plans are billed in advance (monthly or annual). You can cancel anytime from Billing — when you cancel Pro, you revert to Free without losing data. No refunds for partial periods.",
    "section_4_title": "Your content",
    "section_4_body": "Your content remains yours. You grant us a limited license to process and display it as needed to operate the service (for example, transcribing meetings, syncing tasks).",
    "section_5_title": "Service \"as is\"",
    "section_5_body": "We do our best to keep Tworks stable and available, but the service is provided \"as is\" without warranties. We're not liable for indirect damages from use.",
    "section_6_title": "Changes",
    "section_6_body": "We may update these terms. We'll notify you by email 30 days in advance if changes are material.",
    "section_7_title": "Contact",
    "section_7_body": "hola{'@'}pavemi.com",
    "back": "Back to home"
  },
  "changelog": {
    "kicker": "Changelog",
    "title": "What's new",
    "intro": "Everything we've shipped and improved in Tworks, month by month.",
    "badge_new": "New",
    "badge_imp": "Improved",
    "badge_fix": "Fixed",
    "back": "Back to home",
    "releases": [
      {
        "period": "July 2026",
        "items": [
          {
            "type": "new",
            "text": "Subtasks with their own assignee: give each subtask to a different person."
          },
          {
            "type": "new",
            "text": "One task in multiple projects: it shows up on every board you link it to, with its status kept in sync."
          },
          {
            "type": "new",
            "text": "Personal board in My Tasks, with columns you define yourself."
          },
          {
            "type": "new",
            "text": "Favorite projects and teams so you reach your daily work faster."
          },
          {
            "type": "imp",
            "text": "Clearer, more intuitive workspace switching."
          }
        ]
      },
      {
        "period": "June 2026",
        "items": [
          {
            "type": "new",
            "text": "Share any task with a direct link."
          },
          {
            "type": "new",
            "text": "Get notified when someone completes a task you created."
          },
          {
            "type": "imp",
            "text": "Rename the columns of your personal board."
          },
          {
            "type": "imp",
            "text": "The PDF report now includes your latest completed tasks."
          }
        ]
      },
      {
        "period": "May 2026",
        "items": [
          {
            "type": "new",
            "text": "Multiple workspaces: create separate spaces and switch between them without leaving the app."
          },
          {
            "type": "new",
            "text": "Android app (direct download from the site)."
          },
          {
            "type": "imp",
            "text": "Stability and performance improvements across the app."
          }
        ]
      },
      {
        "period": "April 2026",
        "items": [
          {
            "type": "new",
            "text": "AI Meetings: record from the browser, get a transcript and summary, and turn decisions into tasks with one click."
          },
          {
            "type": "new",
            "text": "Pro and Business plans, with 14 days of Pro free when you sign up."
          },
          {
            "type": "imp",
            "text": "Complete redesign of the meetings view."
          }
        ]
      }
    ]
  },
  "security": {
    "title": "Security",
    "last_updated": "Last updated: July 2026",
    "intro": "How we protect your team's data in Tworks, from the connection to storage.",
    "section_1_title": "Encryption in transit",
    "section_1_body": "All communication between your browser (or the mobile app) and our servers is encrypted with TLS.",
    "section_2_title": "Authentication and access",
    "section_2_body": "Passwords are stored hashed — never in plain text. You can sign in with Google. Sessions use revocable tokens, and public API keys carry scoped permissions confined to the v1 API.",
    "section_3_title": "Team isolation",
    "section_3_body": "Tworks is multi-tenant: every request verifies you belong to the team and project you are trying to access. Data from one workspace never mixes with another.",
    "section_4_title": "Meeting audio",
    "section_4_body": "Your meeting audio is stored privately, with no public URLs, and is automatically deleted after 90 days (configurable per team). The providers that process transcriptions are listed in our privacy policy.",
    "section_5_title": "Infrastructure",
    "section_5_body": "Your data lives in PostgreSQL with access restricted to the application, following the principle of least privilege.",
    "section_6_title": "Report a vulnerability",
    "section_6_body": "Found a security issue? Write to us at hola{'@'}pavemi.com. We appreciate responsible disclosure and reply promptly.",
    "back": "Back to home"
  }
}
